import './dataDisplayCell.scss';

import classNames from 'classnames';
import React from 'react';

interface DataDisplayCellProps {
  additionalClass?: string;
  dataLabel: string;
  dataValue?: string;
  dataLabelStyles?: React.CSSProperties | undefined;
  dataValueTestid?: string;
  multiline?: boolean;
  multiLines?: string[];
  /** When true, mask in replay. Ignored if phiHidden is true. Only one of hidden/sanitize is applied. */
  phiSanitize?: boolean;
  /** When true, fully hidden in replay. Overrides phiSanitize; only one attribute is applied. */
  phiHidden?: boolean;
}

function DataDisplayCell({
  dataLabel,
  dataValue,
  additionalClass,
  multiline,
  multiLines,
  dataLabelStyles,
  dataValueTestid,
  phiSanitize,
  phiHidden,
}: DataDisplayCellProps) {
  const openReplayAttrs = phiHidden
    ? { 'data-openreplay-hidden': true }
    : phiSanitize
      ? { 'data-openreplay-sanitize': true }
      : {};
  return (
    <p className={classNames('data_display_wrapper', additionalClass || null)}>
      <strong className='data_label' style={dataLabelStyles}>
        {dataLabel}
      </strong>
      {!multiline ? (
        <span className='data_value' data-testid={dataValueTestid} {...openReplayAttrs}>
          {dataValue}
        </span>
      ) : (
        <span className='data_value' data-testid={dataValueTestid} {...openReplayAttrs}>
          {(multiLines || []).map((line, index) => (
            <span key={`${index}-${line}`} className='d-block'>
              {line}
            </span>
          ))}
        </span>
      )}
    </p>
  );
}

export default DataDisplayCell;
